/* Colecciones y campaña: mejora progresiva, desplazamiento nativo. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function setup(scope = document) {
    scope.querySelectorAll('[data-collection-edit]').forEach(section => {
      if (section.dataset.editReady) return;
      section.dataset.editReady = 'true';
      const tabs = [...section.querySelectorAll('[data-edit-tab]')];
      const panels = [...section.querySelectorAll('[data-edit-panel]')];
      section.querySelector('.brief-edit-tabs').setAttribute('role', 'tablist');
      const choose = (index, focus = false, interaction = false) => {
        const rail = section.querySelector('.brief-edit-tabs');
        const current = panels.find(panel => !panel.hidden);
        const resetPosition = interaction && matchMedia('(max-width:749px)').matches && current && current.getBoundingClientRect().top < rail.getBoundingClientRect().bottom - 24;
        tabs.forEach((tab, i) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', String(i === index));
          tab.removeAttribute('aria-current');
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus({preventScroll:true});
        const tabRail = section.querySelector('.brief-edit-tabs');
        const tabBounds = tabs[index].getBoundingClientRect();
        const railBounds = tabRail.getBoundingClientRect();
        const offset = tabBounds.left < railBounds.left ? tabBounds.left - railBounds.left : tabBounds.right > railBounds.right ? tabBounds.right - railBounds.right : 0;
        if (offset) tabRail.scrollBy({left:offset,behavior:reduced.matches?'auto':'smooth'});
        if (resetPosition) {
          const inset = parseFloat(getComputedStyle(tabRail).top) || 0;
          window.scrollTo({top:window.scrollY + panels[index].getBoundingClientRect().top - tabRail.offsetHeight - inset - 20,behavior:reduced.matches?'auto':'smooth'});
        }
        if (!reduced.matches && panels[index].animate) panels[index].animate([{opacity:.5},{opacity:1}],{duration:220,easing:'ease-out'});
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault(); choose(index, false, true);
        });
        tab.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); choose(index, false, true); return; }
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); choose(next, true, true);
        });
      });
      choose(0);
    });
    scope.querySelectorAll('[data-brief-cover]').forEach(section => {
      if (section.dataset.coverReady) return;
      section.dataset.coverReady = 'true';
      const rail = section.querySelector('[data-rail]');
      const frames = [...section.querySelectorAll('[data-cover-frame]')];
      const mobile = matchMedia('(max-width:749px)');
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const index = mobile.matches ? Math.min(frames.length - 1, Math.round(rail.scrollLeft / rail.clientWidth)) : 0;
        frames.forEach((frame, i) => { frame.inert = mobile.matches && index !== i; });
        section.querySelector('[data-cover-count]').textContent = `${String(index + 1).padStart(2, '0')} / 02`;
      };
      rail.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }, {passive:true});
      new ResizeObserver(update).observe(rail); mobile.addEventListener('change', update); update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
